import { render, staticRenderFns } from "./jianLi.vue?vue&type=template&id=3241563b&scoped=true&"
import script from "./jianLi.vue?vue&type=script&lang=js&"
export * from "./jianLi.vue?vue&type=script&lang=js&"
import style0 from "./jianLi.vue?vue&type=style&index=0&id=3241563b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241563b",
  null
  
)

export default component.exports